import React from 'react';
export var GridContext = /*#__PURE__*/React.createContext({
  gapHorizontal: 0
});
//# sourceMappingURL=GridContext.js.map